import type { ReactElement, ReactNode } from 'react';
import { useTracking } from 'react-tracking';
import { SWS_IMAGES } from '@/constants';
import { SnowflakeHelp } from '@components/Help';
import ChartWrapper from '@/pages/CompanyReport/components/Overview/components/ChartWrapper';
import { useOverviewTranslation } from '../hooks/useOverviewTranslation';

interface Props {
  id?: string;
  points: number[];
  feedbackLabel?: string;
  companyForFeedback?: string;
  chart?: ReactElement;
  table?: ReactNode;
  preRenderHeight?: string | number;
  preRenderMinHeightSmDown?: string | number;
}

export function SnowflakeChartWrapper({
  id = '',
  feedbackLabel,
  companyForFeedback,
  chart,
  table,
  points,
  preRenderHeight = 338,
  preRenderMinHeightSmDown = 225,
}: Props) {
  const { Track } = useTracking({
    type: 'track',
    subject: 'chart',
    title: 'snowflake',
  });
  const getExportUrl = (theme: 'dark' | 'light') => {
    const valuationScore = points && points.length > 0 ? points[0] : 0;
    const futureScore = points && points.length > 1 ? points[1] : 0;
    const pastScore = points && points.length > 2 ? points[2] : 0;
    const financialScore = points && points.length > 3 ? points[3] : 0;
    const dividendScore = points && points.length > 4 ? points[4] : 0;

    const snowflakeTheme = theme === 'light' ? 'light' : 'dark';
    return `${SWS_IMAGES}/snowflake/?points[]=${valuationScore}&points[]=${futureScore}&points[]=${pastScore}&points[]=${financialScore}&points[]=${dividendScore}&theme=${snowflakeTheme}&size=small` as const;
  };
  const darkUrl = getExportUrl('dark');
  const lightUrl = getExportUrl('light');

  const t = useOverviewTranslation();
  return (
    <Track>
      <ChartWrapper
        chart={chart}
        table={table}
        id={id}
        helpTitle={t('snowflake.about.title')}
        help={<SnowflakeHelp />}
        exportDarkUrl={darkUrl}
        exportLightUrl={lightUrl}
        feedbackLabel={feedbackLabel}
        companyName={companyForFeedback as string}
        keepChartRendered={false}
        actionsMarginTop={8}
        preRenderHeight={preRenderHeight}
        preRenderMinHeightSmDown={preRenderMinHeightSmDown}
      />
    </Track>
  );
}

export default SnowflakeChartWrapper;
